import { render, staticRenderFns } from "./MpCrossword.vue?vue&type=template&id=589803f0&scoped=true&"
import script from "./MpCrossword.vue?vue&type=script&lang=js&"
export * from "./MpCrossword.vue?vue&type=script&lang=js&"
import style0 from "./MpCrossword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MpCrossword.vue?vue&type=style&index=1&id=589803f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589803f0",
  null
  
)

export default component.exports